"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const i=require("@mui/material"),t=require("@mui/material/styles"),n=t.styled("div")`
  display: flex;
  gap: 8px;
`,l=t.styled("div")`
  max-width: 200px;
`,o=632,r=432,a=t.styled("div")`
  width: ${({isWide:e})=>`${e?o:r}px`};
  min-width: ${({isWide:e})=>`${e?o:r}px`};
  flex-grow: 0;
  overflow: auto;
`,p=t.styled("div")`
  height: 56px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`,s=t.styled(i.FormControlLabel)(({theme:e})=>({marginLeft:"3px",gap:"16px",color:e.palette.grey[800],fontFamily:"Lato",fontSize:"16px",fontStyle:"normal",fontWeight:400,lineHeight:"22px",letterSpacing:"0.5px"})),d=t.styled(i.Alert)`
  width: 100%;
  margin-bottom: 8px;
`;exports.BlockingFormField=s;exports.DurationWrapper=l;exports.FormWrapper=a;exports.LoaderWrapper=p;exports.Row=n;exports.Warning=d;
